import axios from 'axios';
import $http from '@/core/services/http.service';
import {ActionTree} from 'vuex';

import {State} from '@/manager/convocation/store/state';
import Endpoints from '@/constants/endpoints';
import UtilsService from '@/core/services/utils.service';

export interface Actions {
    setConvocationsList: {};
    setNextConvocationList: {};
    uploadConvocationClients: {};
    uploadConvocationCSV: {};
    setDelegationList: {};
    patchParticipant: { participantId: string; convocationId: string; data: any };
    fetchConvocationList: {};
    fetchNextConvocationList: { id: string };
    fetchDelegationList: {};
    fetchParticipantList: { id: string };
    fetchConvocation: { id: string };
    fetchPaymentStatus: {};
    fetchConvocationHeaders: { id: string };
    undoPostponementConvocation: { participantId: string };
}

export const actions: ActionTree<State, any> = {
    setConvocationsList: ({commit}, payload) => {
        commit('setConvocationsList', payload);
    },
    setNextConvocationList: ({commit}, payload) => {
        commit('setNextConvocationList', payload);
    },
    setDelegationList: ({commit}, payload) => {
        commit('setDelegationList', payload);
    },
    changeParticipantConvocation: ({commit}, payload) => {
        return new Promise((resolve, reject) => {
            const params: any = {
                manual: true,
                justified: true,
            };
            if (payload.newConvocationId) {
                params.convocation_target = payload.newConvocationId;
            }
            $http
                .post(
                    `${Endpoints.participant}${payload.participantId}/postponement/`,
                    params,
                )
                .then((res) => {
                    commit('updateParticipant', res.data);
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    uploadConvocationCSV: ({commit}, {file, url, convocation_id}) => {
        return new Promise((resolve) => {
            
            const formData = new FormData();
            formData.append('file', file);
            if (convocation_id) {
                formData.append('convocation', convocation_id);
            }
            $http
                .post(
                    `${url}`,
                    formData,
                )
                .then((res) => {
                    resolve('Operación realizada con éxito');
                })
                .catch((err) => {
                    resolve('Hemos presentado dificultades para subir el archivo');
                });
        });

    },
    postponeParticipantConvocation: ({commit}, payload) => {
        return new Promise((resolve, reject) => {
            const params: any = {
                manual: false,
                justified: payload.justified,
            };
            if (payload.newConvocationId) {
                params.convocation_target = payload.newConvocationId;
            }
            if (payload.noteList) {
                params.note_list = payload.noteList;
            }
            if (payload.tagList) {
                params.tag_list = payload.tagList;
            }
            $http
                .post(
                    `${Endpoints.participant}${payload.participantId}/postponement/`,
                    params,
                )
                .then((res) => {
                    commit('updateParticipant', res.data);
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    fetchConvocationList: ({commit}, payload) => {
        return new Promise((resolve, reject) => {
            const officeSale = {office_sales: false};
            let params: any = {};
            params = UtilsService.getQueryParams(payload);
            params = {...params, ...officeSale};
            if (params.limit < -1) {
                delete params.limit;
            }
            $http
                .get(`${Endpoints.convocation}`, {params})
                .then((res) => {
                    const data = res.data;
                    commit('setConvocationsList', data.results);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    fetchNextConvocationList: ({commit}, payload) => {
        return new Promise((resolve, reject) => {
            $http
                .get(`${Endpoints.convocation}${payload.id}/next`)
                .then((res) => {
                    const data = res.data.results;
                    commit('setNextConvocationList', data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    fetchConvocationHeaders: ({commit, getters}, payload) => {
        return new Promise((resolve, reject) => {
            $http
                .head(`${Endpoints.convocation}${payload.id}/`)
                .then((res) => {
                    commit('updateConvocationHeaders', {
                        idConvocation: payload.id,
                        totalParticipantSummoned:
                            res.headers['x-total-participant-summoned'],
                        totalParticipantConfirmed:
                            res.headers['x-total-participant-confirmed'],
                        totalParticipantChecked: res.headers['x-total-participant-checked'],
                        totalParticipantOut: res.headers['x-total-participant-out'],
                        totalParticipantPostpone:
                            res.headers['x-total-participant-postpone'],
                        totalParticipantNotConfirmed:
                            res.headers['x-total-participant-not-confirmed'],
                        totalParticipantAbandonment:
                            res.headers['x-total-participant-abandonment'],
                        totalParticipantEnrolled:
                            res.headers['x-total-participant-enrolled'],
                    });
                    resolve(res.headers);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    fetchConvocation: ({commit, getters}, payload) => {
        return new Promise((resolve, reject) => {
            const convocation = getters.getConvocation(payload.id);
            $http
                .get(`${Endpoints.convocation}${payload.id}/`)
                .then((res) => {
                    const data = res.data;
                    if (convocation) {
                        commit('updateConvocation', data);
                    } else {
                        commit('newConvocation', data);
                    }
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    fetchConvocationFromBudget: ({commit, getters}, payload) => {
        return new Promise((resolve, reject) => {
            // const convocation = getters.getConvocation(payload.id);
            $http
                // .get(`${Endpoints.convocation}${payload.id}/`)
                .get(`${Endpoints.convocation}${payload.id}/convocation-from-budget/`)
                .then((res) => {
                    const data = res.data.detail;
                    // commit('updateConvocation', data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    updateConvocation: ({commit, getters}, payload) => {
        return new Promise((resolve, reject) => {
            
            let params: any = {};
            params = UtilsService.getQueryParams(payload)
            $http
                .put(`${Endpoints.convocation}${params.id}/`, {params})
                .then((res) => {
                    const data = res.data;
                    commit('updateConvocation', data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    fetchConvocationPublic: ({commit, getters}, payload) => {
        return new Promise((resolve, reject) => {
            $http
                .get(`${Endpoints.convocation}${payload.id}/public`)
                .then((res) => {
                    const data = res.data;
                    commit('setConvocationsList', [data]);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    fetchPaymentStatus: ({commit}, payload) => {
        return new Promise((resolve, reject) => {
            $http
                .get(`${Endpoints.paymentStatus}`)
                .then((res) => {
                    const data = res.data;
                    commit('setPaymentStatusList', data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    fetchParticipant: ({commit}, payload) => {
        return new Promise((resolve, reject) => {
            $http
                .get(`${Endpoints.participant}${payload.id}/`)
                .then((res) => {
                    const data = res.data;
                    commit('newParticipant', data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    deleteParticipant: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
          $http
            .delete(`${Endpoints.participant}${payload.id}/`)
            .then((res) => {
              commit('deleteParticipant', payload);
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        });
      },
    fetchParticipantList: ({commit, getters}, payload) => {
        return new Promise((resolve, reject) => {
            let params: any = {};
            if (payload.filter) {
                const filter = payload.filter;
                for (const key in filter) {
                    if (filter.hasOwnProperty(key)) {
                        const value = filter[key];
                        if (value && key !== 'summoned') {
                            params = Object.assign({}, params, {[key]: value});
                        }
                    }
                }
            }
            if (payload.offset) {
                params.offset = payload.offset;
            }
            if (payload.limit > -1) {
                params.limit = payload.limit;
            }
            if (payload.search) {
                params = Object.assign({}, params, {['search']: payload.search});
            }
            if (payload.searchNif) {
                params = Object.assign({}, params, {['search_nif']: payload.searchNif});
            }
            if (payload.searchPhone) {
                params = Object.assign({}, params, {['search_phone']: payload.searchPhone});
            }
            if (payload.ordering) {
                params = Object.assign({}, params, {['ordering']: payload.ordering});
            }

            const requestData = {
                requestId: new Date().getTime(),
                requestSource: axios.CancelToken.source(),
            };
            commit('emptyParticipantListRequest');
            commit('addParticipantListRequest', requestData);
            setTimeout(() => {
                $http
                    .get(`${Endpoints.convocation}${payload.id}/participant/`, {
                        params,
                        cancelToken: requestData.requestSource.token,
                    })
                    .then((res) => {
                        const participantListRequests = getters.getParticipantListRequests;
                        const participantListRequestsIds = participantListRequests.map(
                            (item: any) => item.requestId,
                        );
                        if (
                            participantListRequestsIds.indexOf(requestData.requestId) > -1
                        ) {
                            commit('removeParticipantListRequest', requestData);
                            const data = res.data.results;
                            commit('setParticipantList', data);
                            resolve(res.data);
                        }
                    })
                    .catch((err) => {
                        reject(err);
                    });
            }, 500);
        });
    },
    fetchWaitingList: ({commit, getters}, payload) => {
        return new Promise((resolve, reject) => {
            let params: any = {
                waiting_list: true,
            };
            if (payload.offset) {
                params.offset = payload.offset;
            }
            if (payload.limit > -1) {
                params.limit = payload.limit;
            }
            if (payload.search) {
                params = Object.assign({}, params, {['search']: payload.search});
            }
            if (payload.ordering) {
                params = Object.assign({}, params, {['ordering']: payload.ordering});
            }
            if (payload.searchNif) {
                params = Object.assign({}, params, {['search_nif']: payload.searchNif});
            }

            setTimeout(() => {
                $http
                    .get(`${Endpoints.convocation}${payload.id}/participant/`, {
                        params,
                    })
                    .then((res) => {
                        const data = res.data.results;
                        commit('setWaitingList', data);
                        commit('setCountWaitingList', res.data.count)
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            }, 500);
        });
    },
    fetchPostponeList: ({commit, getters}, payload) => {
        return new Promise((resolve, reject) => {
            let params: any = {
                pending_postpone: true,
            };
            if (payload.offset) {
                params.offset = payload.offset;
            }
            if (payload.limit > -1) {
                params.limit = payload.limit;
            }
            if (payload.search) {
                params = Object.assign({}, params, {['search']: payload.search});
            }
            if (payload.searchNif) {
                params = Object.assign({}, params, {['search_nif']: payload.searchNif});
            }
            if (payload.ordering) {
                params = Object.assign({}, params, {['ordering']: payload.ordering});
            }

            setTimeout(() => {
                $http
                    .get(`${Endpoints.convocation}${payload.id}/participant/`, {
                        params,
                    })
                    .then((res) => {
                        const data = res.data.results;
                        commit('setPostponeList', data);
                        commit('setCountPostponeList', res.data.count)
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            }, 500);
        });
    },
    fetchRepeaterList: ({commit, getters}, payload) => {
        return new Promise((resolve, reject) => {
            let params: any = {
                waiting_repeater_list: true,
            };
            if (payload.offset) {
                params.offset = payload.offset;
            }
            if (payload.limit > -1) {
                params.limit = payload.limit;
            }
            if (payload.search) {
                params = Object.assign({}, params, {['search']: payload.search});
            }
            if (payload.searchNif) {
                params = Object.assign({}, params, {['search_nif']: payload.searchNif});
            }
            if (payload.ordering) {
                params = Object.assign({}, params, {['ordering']: payload.ordering});
            }

            setTimeout(() => {
                $http
                    .get(`${Endpoints.convocation}${payload.id}/participant/`, {
                        params,
                    })
                    .then((res) => {
                        const data = res.data.results;
                        commit('setRepeaterList', data);
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            }, 500);
        });
    },
    fetchTeamList: ({commit, getters}, payload) => {
        return new Promise((resolve, reject) => {
            let params: any = {
                team_list: true,
            };
            if (payload.offset) {
                params.offset = payload.offset;
            }
            if (payload.limit > -1) {
                params.limit = payload.limit;
            }
            if (payload.search) {
                params = Object.assign({}, params, {['search']: payload.search});
            }
            if (payload.searchNif) {
                params = Object.assign({}, params, {['search_nif']: payload.searchNif});
            }
            if (payload.ordering) {
                params = Object.assign({}, params, {['ordering']: payload.ordering});
            }

            setTimeout(() => {
                $http
                    .get(`${Endpoints.convocation}${payload.id}/participant/`, {
                        params,
                    })
                    .then((res) => {
                        const data = res.data.results;
                        commit('setTeamList', data);
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            }, 500);
        });
    },
    fetchTagList: ({commit, getters}, payload) => {
        let params: any = {};
        params = UtilsService.getQueryParams(payload);

        return new Promise((resolve, reject) => {
            $http
                .get(`${Endpoints.tag}`,{params})
                .then((res) => {
                    const data = res.data.results;
                    commit('setTagList', data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    fetchConvocationNotes: ({commit}, payload) => {
        return new Promise((resolve, reject) => {
            $http
                .get(`${Endpoints.convocation}${payload.convocationId}/note`)
                .then((res) => {
                    const data = res.data.results;
                    commit('setConvocationNotes', data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    fetchParticipantNotes: ({commit}, payload) => {
        return new Promise((resolve, reject) => {
            $http
                .get(`${Endpoints.participant}${payload.participantId}/note`)
                .then((res) => {
                    const data = res.data.results;
                    commit('setParticipantNotes', {
                        participantId: payload.participantId,
                        notes: data,
                    });
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    fetchParticipantLog: ({commit}, payload) => {
        return new Promise((resolve, reject) => {
            $http
                .get(`${Endpoints.participant}${payload.participantId}/log/`)
                .then((res) => {
                    const data = res.data;
                    commit('setParticipantLog', {
                        participantId: payload.participantId,
                        log: data,
                    });
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    fetchParticipantPostponementLog: ({commit}, payload) => {
        return new Promise((resolve, reject) => {
            $http
                .get(`${Endpoints.participant}${payload.participantId}/postponement/`)
                .then((res) => {
                    const data = res.data;
                    commit('setParticipantPostponementLog', {
                        participantId: payload.participantId,
                        log: data,
                    });
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    fetchParticipantTraspasementLog: ({commit}, payload) => {
        return new Promise((resolve, reject) => {
            $http
                .get(`${Endpoints.participant}${payload.participantId}/traspasement/`)
                .then((res) => {
                    const data = res.data;
                    commit('setParticipantTraspasementLog', {
                        participantId: payload.participantId,
                        log: data,
                    });
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    fetchParticipantChecked: ({commit, getters}, payload) => {
        return new Promise((resolve, reject) => {
            const baseUrl = `${Endpoints.convocation}`;
            $http
                .get(
                    `${baseUrl}${payload.convocationId}/participant/update/?checked=true`,
                )
                .then((res) => {
                    const data = res.data.results;
                    data.forEach((participant: any) => {
                        commit('updateParticipantField', participant);
                    });
                    resolve();
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    newConvocationNote: ({commit}, payload) => {
        return new Promise((resolve, reject) => {
            $http
                .post(`${Endpoints.convocation}${payload.convocationId}/note`, {
                    note: payload.note,
                })
                .then((res) => {
                    const data = res.data;
                    commit('newConvocationNote', data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    newParticipantNote: ({commit}, payload) => {
        return new Promise((resolve, reject) => {
            $http
                .post(`${Endpoints.participant}${payload.participantId}/note`, {
                    employee: payload.employee,
                    note: payload.note,
                })
                .then((res) => {
                    const data = res.data;
                    commit('newParticipantNote', data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    removeParticipantNotes: ({commit}, payload) => {
        commit('removeParticipantNotes', {participantId: payload.participantId});
    },
    removeConvocationNote: ({commit}, payload) => {
        return new Promise((resolve, reject) => {
            $http
                .delete(
                    `${Endpoints.convocation}${payload.convocationId}/note/${
                        payload.noteId
                    }/`,
                )
                .then(() => {
                    commit('removeConvocationNote', payload.noteId);
                    resolve(payload.noteId);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    removeParticipantNote: ({commit}, payload) => {
        return new Promise((resolve, reject) => {
            $http
                .delete(
                    `${Endpoints.participant}${payload.participantId}/note/${
                        payload.noteId
                    }/`,
                )
                .then(() => {
                    commit('removeParticipantNote', payload.noteId);
                    resolve(payload.noteId);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    newParticipant: ({commit}, payload) => {
        return new Promise((resolve, reject) => {
            $http
                .post(`${Endpoints.convocation}${payload.convocationId}/participant/`, {
                    client: payload.client,
                    note: payload.note,
                    team: payload.team,
                })
                .then((res) => {
                    const data = res.data;
                    commit('newParticipant', data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    patchConvocationParticipant: ({commit, getters}, payload) => {
        return new Promise((resolve, reject) => {
            $http
                .patch(
                    `${Endpoints.participant}${payload.participantId}/`,
                    payload.data,
                )
                .then((res) => {
                    commit('updateParticipant', res.data);
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    patchConvocationNote: ({commit}, payload) => {
        return new Promise((resolve, reject) => {
            $http
                .patch(
                    `${Endpoints.convocation}${payload.convocationId}/note/${
                        payload.noteId
                    }/`,
                    payload.data,
                )
                .then((res) => {
                    commit('updateConvocationNote', res.data);
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    patchParticipantNote: ({commit}, payload) => {
        return new Promise((resolve, reject) => {
            $http
                .patch(
                    `${Endpoints.participant}${payload.participantId}/note/${
                        payload.noteId
                    }/`,
                    payload.data,
                )
                .then((res) => {
                    commit('updateParticipantNote', res.data);
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    undoPostponementConvocation: ({commit}, payload) => {
        return new Promise((resolve, reject) => {
            $http
                .delete(
                    `${Endpoints.participant}${payload.participantId}/postponement/`,
                )
                .then((res) => {
                    commit('updateParticipant', res.data);
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    moveToWaitingList: ({commit, getters}, payload) => {
        return new Promise((resolve, reject) => {
            $http
                .post(
                    `${Endpoints.participant}${payload.participantId}/to-waiting-list/`,
                    payload
                )
                .then((res) => {
                    commit('updateParticipant', res.data);
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    moveToParticipantList: ({commit, getters}, payload) => {
        return new Promise((resolve, reject) => {
            $http
                .post(
                    `${Endpoints.participant}${
                        payload.participantId
                    }/to-participant-list/`,
                )
                .then((res) => {
                    commit('updateParticipant', res.data);
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    fetchParticipantMassiveEmail: ({commit}, payload) => {
        return new Promise((resolve, reject) => {
            const params = payload.params;
            $http
                .get(
                    `${Endpoints.convocation}${
                        payload.convocationId
                    }/participant/comunication/`,
                    {
                        params,
                    },
                )
                .then((res) => {
                    const data = res.data;
                    commit('setParticipantMassiveEmailList', data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    patchParticipantPurchase: ({commit, getters}, payload) => {
        return new Promise((resolve, reject) => {
            const participant = getters.getParticipant(payload.participantId);
            $http
                .patch(`${Endpoints.purchase}${payload.id}/`, payload.data)
                .then((res) => {
                    participant.purchase = res.data;
                    commit('updateParticipant', participant);
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};
